function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.7357 29.8302C39.0409 29.7678 36.9073 27.5444 36.9701 24.8641C37.0329 22.1839 39.2683 20.0617 41.9631 20.1242C44.658 20.1867 46.7916 22.4101 46.7288 25.0903C46.666 27.7706 44.4305 29.8927 41.7357 29.8302Z",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4374 29.8307C7.74187 29.8307 5.5567 27.6574 5.5567 24.9764C5.5567 22.2954 7.74187 20.1221 10.4374 20.1221C13.1329 20.1221 15.3181 22.2954 15.3181 24.9764C15.3181 27.6574 13.1329 29.8307 10.4374 29.8307Z",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8409 24.8726C32.8437 23.7218 33.0748 22.5828 33.5211 21.5209C33.9674 20.4591 34.6201 19.4954 35.4417 18.685C38.9088 15.2508 44.5329 15.2508 48 18.685",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.25796 24.8724C1.25796 20.0145 5.21708 16.0776 10.1013 16.0776C14.9856 16.0776 18.9438 20.0154 18.9438 24.8732",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2078 6.02637H3.78484V11.0527H20.2078V6.02637Z",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M42.9473 16.078L35.3668 1H30.3132",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8408 24.9766H18.9438",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2079 11.0518C20.2079 11.0518 25.2615 29.8991 35.3669 11.0518",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.78467 11.0518C3.78467 11.0518 -0.0059909 17.3342 1.25786 24.8728",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 31,
    viewBox: "0 0 49 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b95d77f1.svg";
export { ForwardRef as ReactComponent };